/* nuxt-client-init: similar to the store's action nuxtServerInit, this
 * plugin runs in the client side with the context. This is useful if
 * you have to handle data that is only available in the client (like window).
 * Usage is similar as nuxtServerInit: add it to the project's store actions,
 * and don't forget to instantiate modules nuxtClientInit if they have it.
*/

export default async (context) => {
  // eslint-disable-next-line no-underscore-dangle
  if (context.store._actions.nuxtClientInit) {
    await context.store.dispatch('nuxtClientInit', context);
  }
};
